<template>
  <div class="containerWrap" :class="{'containerColumn':isColumn}" :style="computedStyle">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'containerWrap',
  props: {
    isColumn: {
       type:Boolean,
       default:false
    },
    width:{
      type:String,
      default:'100%'
    },
    height:{
      type:String,
      default:'100%'
    },
    padding:{
      type:String,
      default:'0px'
    },
    margin:{
      type:String,
      default:'0px'
    },
    alignItems:{
      type:String,
      default:'normal'
    },
    justifyContent:{
      type:String,
      default:'normal'
    }
  },
  computed:{
    computedStyle(){
      return {
        width:this.width,
        height:this.height,
        padding:this.padding,
        margin:this.margin,
        justifyContent:this.justifyContent,
        alignItems:this.alignItems
      }
    }
  },
  data() {
    return {}
  },
  created() {},
  mounted() {},
}
</script>
<style lang="scss" scoped>
.containerWrap {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: hidden;
}
.containerColumn{
  flex-direction: column;
}
</style>
<style lang="scss">
.containerWrap {}
</style>